<div class="balance-consult-component-new container-fluid" #balance>
  <div class="row header d-flex m-0" #header>
    <div class="financial col-md-12 d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <mat-icon class="icon icon-order mr-1 w-30" svgIcon="coin"></mat-icon>
        <span class="mr-3 title">{{ title }}</span>
        <button mat-mini-fab class="button-visibility" (click)="showHideValues()">
          <mat-icon *ngIf="showValues" class="icon pointer" svgIcon="no-visibility"></mat-icon>
          <mat-icon *ngIf="!showValues" class="icon pointer" svgIcon="visibility"></mat-icon>
        </button>
      </div>
      <mat-icon class="close-btn" svgIcon="close" (click)="close()"></mat-icon>
    </div>
  </div>
  <div class="header">
    <div class="network-error-message-oms" *ngIf="!statusOmsOnline">{{ msgStatusOmsOffile }}</div>
  </div>
  <div class="scrollable-body" [ngClass]="{'center-items-window': !showlayoutFullSocket}" #body>
    <div *ngIf="loading" class="spinner">
      <app-spinner-loading></app-spinner-loading>
    </div>
    <ng-container *ngIf="showlayoutFullSocket; then layoutFullSocket; else layoutMiniRest"></ng-container>
  </div>
</div>

<ng-template #layoutMiniRest>
  <div class="row box-rest" *ngIf="!loading && cardsConfig">
    <div class="col-12 mb-card mt-title">
      <span>Conta:</span>
      <span class="value pad">{{ account }}</span>
    </div>
    <div class="col-12 box-update mb-title">
      <span>Atualizado pela última vez</span>
      <span class="value pad">{{ dateRequestRest | date: 'dd/MM/yyyy' }}</span>
      <span>às</span>
      <span class="value pad">{{ dateRequestRest | date: 'HH:mm:ss' }}</span>
      <span class="update" (click)="retry()">
        <mat-icon class="icon pointer exclamation-mark" svgIcon="retry"></mat-icon>
        Atualizar
      </span>
    </div>
    <div class="col-12">
      <div class="row">
        <div class="col-12 col-md-6 mb-card">
          <mat-card class="balance">
            <mat-card-header class="pb-1">
              <span class="title">Saldo disponível</span>
            </mat-card-header>
            <mat-card-content class="d-flex">
              <span class="value" [ngClass]="showValues ? 'hidden' : ''">{{ availableBalanceStr }}</span>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-12 col-md-6 mb-card">
          <mat-card class="balance">
            <mat-card-header class="pb-1">
              <span class="title">D1</span>
            </mat-card-header>
            <mat-card-content class="d-flex">
              <span class="value" [ngClass]="showValues ? 'hidden' : ''">{{ balanceD1 }}</span>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-12 col-md-6 mb-card">
          <mat-card class="balance">
            <mat-card-header class="pb-1">
              <span class="title">Limite operacional</span>
            </mat-card-header>
            <mat-card-content class="d-flex">
              <span class="value" [ngClass]="showValues ? 'hidden' : ''">{{ operatingLimit }}</span>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-12 col-md-6 mb-card">
          <mat-card class="balance">
            <mat-card-header class="pb-1">
              <span class="title">D2</span>
            </mat-card-header>
            <mat-card-content class="d-flex">
              <span class="value" [ngClass]="showValues ? 'hidden' : ''">{{ balanceD2 }}</span>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #layoutFullSocket>
  <div class="row" *ngIf="!loading && cardsConfig">
    <div class="col-12 mb-2 custom-page-message" *ngIf="cardsConfig?.infoMessage && cardsConfig?.infoMessage?.active">
      <mat-card>
        <mat-card-content class="value" [innerHTML]="cardsConfig?.infoMessage?.message">
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-12 mb-2">
      <div class="row">
        <div class="col-4" *ngIf="cardsConfig?.balanceAccount"
          [ngClass]="{'col-6': !cardsConfig?.balanceProjectedOnline || !cardsConfig?.patrimonyOnline, 'col-12': !cardsConfig?.balanceProjectedOnline && !cardsConfig?.patrimonyOnline}">
          <mat-card class="balance">
            <mat-card-header class="pb-1">
              <span class="title">Saldo em C/C</span>
            </mat-card-header>
            <mat-card-content class="d-flex">
              <span class="value" [ngClass]="showValues ? 'hidden' : ''">R$ {{ availableBalanceStr }}</span>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-4" *ngIf="cardsConfig?.balanceProjectedOnline"
          [ngClass]="{'col-6': !cardsConfig?.balanceAccount || !cardsConfig?.patrimonyOnline, 'col-12': !cardsConfig?.balanceAccount && !cardsConfig?.patrimonyOnline}">
          <mat-card class="balance">
            <mat-card-header class="pb-1">
              <span class="title">Saldo Projetado Online</span>
            </mat-card-header>
            <mat-card-content>
              <span class="value" [ngClass]="showValues ? 'hidden' : ''">R$ {{ balanceProjOnline }}</span>
              <app-custom-tooltip position="BOTTOM_LEFT" eventTrigger="CLICK"
                *ngIf="cardsConfig?.detailBalanceProjectedOnline">
                <div custom-tooltip-content>
                  <ng-container *ngTemplateOutlet="detailBalanceProjectedOnline"></ng-container>
                </div>
                <div class="show-more-limit-opetarional" custom-tooltip-button>
                  <mat-icon class="icon pointer exclamation-mark" svgIcon="exclamation-mark"></mat-icon><br>
                  <span>Ver mais</span>
                </div>
              </app-custom-tooltip>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-4" *ngIf="cardsConfig?.patrimonyOnline"
          [ngClass]="{'col-6': !cardsConfig?.balanceAccount || !cardsConfig?.balanceProjectedOnline, 'col-12': !cardsConfig?.balanceAccount && !cardsConfig?.balanceProjectedOnline}">
          <mat-card class="patrimony">
            <mat-card-header class="pb-1">
              <span class="title">Patrimônio Online</span>
              <span class="pointer" *ngIf="cardsConfig?.tooltipsPatrimony?.isTooltip"
                (click)="viewTooltipHelp = !viewTooltipHelp">
                <span class="material-icons icon-help">help_outline</span>
              </span>
              <div class="view-more-card" *ngIf="cardsConfig?.tooltipsPatrimony?.isTooltip"
                [ngClass]="viewTooltipHelp ? 'show':''" (mouseleave)="viewTooltipHelp = !viewTooltipHelp">
                <mat-card class="mb-2 box-mat-card-tooltip">
                  <mat-card-content>
                    <span class="text-title-tooltip">
                      {{cardsConfig?.tooltipsPatrimony?.tooltip?.onlineHeritageResponse}}
                    </span>
                    <div class="d-flex justify-content-between">
                      <div class="mr-1">
                        <ul class="box-text"
                          *ngFor="let item of cardsConfig?.tooltipsPatrimony?.tooltip?.onlineHeritageResponse">
                          <li>{{item}}</li>
                        </ul>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </mat-card-header>
            <mat-card-content>
              <span class="value" [ngClass]="showValues ? 'hidden' : ''">R$ {{ onlinePatrimonyStr }}</span>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row">
        <div class="col-8" [ngClass]="{'col-12': (!cardsConfig?.operationalLimit && !cardsConfig?.lossProfitDayTrade && !cardsConfig?.bmfAdjustments)
          || (!cardsConfig?.balanceAccount && !cardsConfig?.balanceProjectedOnline && !cardsConfig?.patrimonyOnline) }"
          *ngIf="cardsConfig?.position">
          <mat-card class="graphic">
            <mat-card-header class="pb-1">
              <span class="title">Posição</span>
            </mat-card-header>
            <mat-card-content>
              <div class="row align-items-center"
                *ngIf="wallet.length > 0 && cardsConfig?.positionDetail; else noProfile">
                <div class="col-6">
                  <div #chart id="chart"></div>
                </div>
                <div class="col-6 custom-legend">
                  <div class="row custom-legend-item content" *ngIf="cardsConfig?.positionDetail.onlineCustodyStr">
                    <div class="col-7">
                      <span class="value-left color-custody">Custódia Online</span>
                    </div>
                    <div class="col-5 r">
                      <span class="value-right" [ngClass]="showValues ? 'hidden-graphic' : ''">R$ {{ onlineCustodyStr
                        }}</span>
                    </div>
                    <div class="detail-option"></div>
                  </div>
                  <div class="row custom-legend-item content" *ngIf="cardsConfig?.positionDetail.earningsStr">
                    <div class="col-7">
                      <span class="value-left color-earnings">Proventos</span>
                    </div>
                    <div class="col-5 r">
                      <span class="value-right" [ngClass]="showValues ? 'hidden-graphic' : ''">R$ {{ earningsStr
                        }}</span>
                    </div>
                  </div>
                  <div class="row custom-legend-item content" *ngIf="cardsConfig?.positionDetail.guaranteeStr">
                    <div class="col-7">
                      <span class="value-left color-guarantee">Garantia</span>
                    </div>
                    <div class="col-5 r">
                      <span class="value-right" [ngClass]="showValues ? 'hidden-graphic' : ''">R$ {{ guaranteeStr
                        }}</span>
                      <div class="detail-option position-abs">
                        <app-custom-tooltip position="TOP_LEFT">
                          <div custom-tooltip-content>
                            <ng-container *ngTemplateOutlet="guaranteeDetail"></ng-container>
                          </div>
                        </app-custom-tooltip>
                      </div>
                    </div>
                  </div>
                  <div class="row custom-legend-item content" *ngIf="cardsConfig?.positionDetail.directTreasuryStr">
                    <div class="col-7">
                      <span class="value-left color-treasure">Tesouro Direto</span>
                    </div>
                    <div class="col-5 r">
                      <span class="value-right" [ngClass]="showValues ? 'hidden-graphic' : ''">R$ {{ directTreasuryStr
                        }}</span>
                    </div>
                  </div>
                  <div class="row custom-legend-item content" *ngIf="cardsConfig?.positionDetail.fixedIncomeStr">
                    <div class="col-7">
                      <span class="value-left color-fixed-income">Renda Fixa</span>
                    </div>
                    <div class="col-5 r">
                      <span class="value-right" [ngClass]="showValues ? 'hidden-graphic' : ''">R$ {{ fixedIncomeStr
                        }}</span>
                    </div>
                  </div>
                  <div class="row custom-legend-item content" *ngIf="cardsConfig?.positionDetail.fundsStr">
                    <div class="col-7">
                      <span class="value-left color-funds">Fundos</span>
                    </div>
                    <div class="col-5 r">
                      <span class="value-right" [ngClass]="showValues ? 'hidden-graphic' : ''">R$ {{ fundsStr
                        }}</span>
                    </div>
                  </div>
                  <div class="row custom-legend-item content" *ngIf="cardsConfig?.positionDetail.clubsStr">
                    <div class="col-7">
                      <span class="value-left color-clubs">Clubes</span>
                    </div>
                    <div class="col-5 r">
                      <span class="value-right" [ngClass]="showValues ? 'hidden-graphic' : ''">R$ {{ clubsStr
                        }}</span>
                    </div>
                  </div>
                  <div class="row custom-legend-item content" *ngIf="cardsConfig?.positionDetail.balanceProjOnline">
                    <div class="col-7">
                      <span class="value-left color-designed-online">Projetado Online</span>
                    </div>
                    <div class="col-5 r">
                      <span class="value-right" [ngClass]="showValues ? 'hidden-graphic' : ''">R$ {{ balanceProjOnline
                        }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #noProfile>
                <app-empty-result></app-empty-result>
              </ng-template>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-4"
          [ngClass]="{'col-12': (!cardsConfig?.position) || (!cardsConfig?.balanceAccount && !cardsConfig?.balanceProjectedOnline && !cardsConfig?.patrimonyOnline)}">
          <div class="row">
            <div class="col-12 mb-2"
              [ngClass]="{'col-sm-4': (!cardsConfig?.balanceAccount && !cardsConfig?.balanceProjectedOnline && !cardsConfig?.patrimonyOnline)}"
              *ngIf="cardsConfig?.operationalLimit">
              <mat-card class="card-item-balance operational">
                <mat-card-header class="pb-1">
                  <span class="title">Limite operacional</span>
                  <app-custom-tooltip *ngIf="cardsConfig?.tooltipsPatrimony?.isTooltip" position="BOTTOM_LEFT"
                    eventTrigger="CLICK">
                    <div custom-tooltip-content>
                      <ng-container *ngTemplateOutlet="tooltipBalanceTemplate"></ng-container>
                    </div>
                  </app-custom-tooltip>
                </mat-card-header>
                <mat-card-content>
                  <span class="value" [ngClass]="showValues ? 'hidden' : ''">
                    R$ {{ operationalLimitStr ? operationalLimitStr : '-' }}
                  </span>
                  <app-custom-tooltip position="BOTTOM_LEFT" eventTrigger="CLICK">
                    <div custom-tooltip-content>
                      <ng-container *ngTemplateOutlet="limitOperationalDetail"></ng-container>
                    </div>
                    <div class="show-more-limit-opetarional" custom-tooltip-button>
                      <mat-icon class="icon pointer exclamation-mark" svgIcon="exclamation-mark"></mat-icon><br>
                      <span>Ver mais</span>
                    </div>
                  </app-custom-tooltip>
                </mat-card-content>
              </mat-card>
            </div>
            <div class="col-12 mb-2"
              [ngClass]="{'col-sm-4': (!cardsConfig?.balanceAccount && !cardsConfig?.balanceProjectedOnline && !cardsConfig?.patrimonyOnline)}"
              *ngIf="cardsConfig?.lossProfitDayTrade">
              <mat-card class="card-item-balance profit">
                <mat-card-header class="pb-1">
                  <span class="title">Lucro/Prejuízo do day trade</span>
                </mat-card-header>
                <mat-card-content>
                  <div class="row">
                    <div class="col-7 value-left">Lucro / Prejuízo Aberto:</div>
                    <div class="col-5 r">
                      <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">{{ profitLossOpenStr }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-7 value-left">Lucro / Prejuízo Fechado:</div>
                    <div class="col-5 r">
                      <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">{{ profitLossCloseStr }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-7 value-left">Lucro / Prejuízo Total:</div>
                    <div class="col-5 r">
                      <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">{{ profitLossTotalStr }}</span>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
            <div class="col-12 mb-2"
              [ngClass]="{'col-sm-4': (!cardsConfig?.balanceAccount && !cardsConfig?.balanceProjectedOnline && !cardsConfig?.patrimonyOnline)}"
              *ngIf="cardsConfig?.bmfAdjustments">
              <mat-card class="card-item-balance adjustment">
                <mat-card-header class="pb-1">
                  <span class="title">Ajuste BM&F</span>
                </mat-card-header>
                <mat-card-content>
                  <div class="row">
                    <div class="col-7 value-left">Ajuste posição:</div>
                    <div class="col-5 r">
                      <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">{{ positionAdjustmentStr
                        }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-7 value-left">Ajuste pregão:</div>
                    <div class="col-5 r">
                      <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">{{ tradingSessionStr }}</span>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #detailBalanceProjectedOnline>
  <div class="detail-balance-projected-online-wrapper">
    <div class="d-flex justify-content-between flex-wrap w-100">
      <span class="value-left">D+0</span>
      <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">R$ {{balanceD0}}</span>
    </div>
    <div class="d-flex justify-content-between flex-wrap w-100">
      <span class="value-left">D+1</span>
      <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">R$ {{balanceD1}}</span>
    </div>
    <div class="d-flex justify-content-between flex-wrap w-100">
      <span class="value-left">D+2</span>
      <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">R$ {{balanceD2}}</span>
    </div>
  </div>
</ng-template>

<ng-template #tooltipBalanceTemplate>
  <mat-card class="mb-2" class="box-mat-card-tooltip tooltip-balance mat-elevation-z0">
    <mat-card-content>
      <div class="mb-1">
        <span class="text-title-tooltip">{{cardsConfig?.tooltipsPatrimony?.tooltip?.operationalLimitTitle}}</span>
      </div>
      <div class="d-flex justify-content-between">
        <table class="box-table">
          <tr>
            <th *ngFor="let item of cardsConfig?.tooltipsPatrimony?.tooltip?.operationalLimitResponse?.header">
              {{item}}
            </th>
          </tr>
          <tr *ngFor="let item of cardsConfig?.tooltipsPatrimony?.tooltip?.operationalLimitResponse?.value">
            <td>{{item.title}}</td>
            <td>{{item.value}}</td>
          </tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>

<ng-template #limitOperationalDetail>
  <div class="limit-operational-detail-wrapper">
    <div *ngIf="loading" class="value spinner">
      <app-spinner-loading [diamet]="20"></app-spinner-loading>
    </div>
    <div class="d-flex flex-wrap info-balance-group justify-content-between" *ngIf="organization && cardsConfig">
      <div *ngIf="cardsConfig?.bmfLeveragedLimitStr" class="d-flex justify-content-between flex-wrap w-100">
        <span class="value-left">Alavancagem BM&F:</span>
        <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">
          R$ {{bmfLeveragedLimitStr}}</span>
      </div>
      <div *ngIf="cardsConfig?.fundLimitStr" class="d-flex justify-content-between flex-wrap w-100">
        <span class="value-left">Limite de Fundos:</span>
        <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">R$ {{fundLimitStr}}</span>
      </div>
      <div *ngIf="cardsConfig?.fixedIncomeLimitStr" class="d-flex justify-content-between flex-wrap w-100">
        <span class="value-left">Limite de Renda Fixa:</span>
        <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">R$ {{fixedIncomeLimitStr}}</span>
      </div>
      <div *ngIf="cardsConfig?.directTreasuryLimitStr" class="d-flex justify-content-between flex-wrap w-100">
        <span class="value-left">Limite de Tesouro Direto:</span>
        <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">
          R$ {{directTreasuryLimitStr}}</span>
      </div>
      <div *ngIf="cardsConfig?.withdrawLimitStr" class="d-flex justify-content-between flex-wrap w-100">
        <span class="value-left">Limite para saque:</span>
        <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">R$ {{withdrawLimitStr}}</span>
      </div>
      <div *ngIf="cardsConfig?.withdrawLimitUsedStr" class="d-flex justify-content-between flex-wrap w-100">
        <span class="value-left">Saldo para saque utilizado:</span>
        <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">
          R$ {{withdrawLimitUsedStr}}</span>
      </div>
      <div *ngIf="cardsConfig?.bmfLimitStr" class="d-flex justify-content-between flex-wrap w-100">
        <span class="value-left">Limite BM&F:</span>
        <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">R$ {{bmfLimitStr}}</span>
      </div>
      <div *ngIf="cardsConfig?.optionLimitStr" class="d-flex justify-content-between flex-wrap w-100">
        <span class="value-left">Limite Opções:</span>
        <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">R$ {{optionLimitStr}}</span>
      </div>
      <div *ngIf="cardsConfig?.cashLeveragedLimitStr" class="d-flex justify-content-between flex-wrap w-100">
        <span class="value-left">Alavancagem Vista:</span>
        <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">
          R$ {{cashLeveragedLimitStr}}</span>
      </div>
      <div *ngIf="cardsConfig?.optionsLeveragedLimitStr" class="d-flex justify-content-between flex-wrap w-100">
        <span class="value-left">Alavancagem opções:</span>
        <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">
          R$ {{optionsLeveragedLimitStr}}</span>
      </div>
      <div *ngIf="cardsConfig?.operationalLimitStr"
        class="d-flex justify-content-between flex-wrap w-100 operational-limity">
        <span class="value-left">Limite Operacional:</span>
        <span class="value-right" [ngClass]="showValues ? 'hidden' : ''">R$ {{operationalLimitStr}}</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #guaranteeDetail>
  <div class="guarantee-detail-wrapper">
    <table>
      <tr>
        <td>Garantia total:</td>
        <td><span class="value-right" [ngClass]="showValues ? 'hidden' : ''">R$ {{guaranteeTotalStr}}</span></td>
      </tr>
      <tr>
        <td>Margem de garantia:</td>
        <td><span class="value-right" [ngClass]="showValues ? 'hidden' : ''">R$ {{guaranteeMargin}}</span></td>
      </tr>
      <tr>
        <td>Garantia considerada no PL:</td>
        <td><span class="value-right" [ngClass]="showValues ? 'hidden' : ''">R$ {{guaranteeConsideratePLStr}}</span>
        </td>
      </tr>
    </table>
  </div>
</ng-template>